import NavItem from '../components/NavItem'

export default {

    components: {
        NavItem,
    },

    data: {
        menuIsOpen: false,
        submenuIsOpen: false,
        menuVisibility: false,
    },

    methods: {
        toggleMenu () {
            const body = document.querySelector('body')

            if (this.menuIsOpen) {
                const menuToggle = this.$el.querySelector('.js-menuToggle')
                this.menuIsOpen = false

                body.classList.remove('-lock')

                setTimeout(() => {
                    this.menuVisibility = false
                    menuToggle.focus()
                }, 250)
            } else {
                this.menuVisibility = true

                body.classList.add('-lock')

                setTimeout(() => {
                    this.menuIsOpen = true
                }, 250)
            }
        },

        closeMenu () {
            const menuToggle = this.$el.querySelector('.js-menuToggle')
            this.menuIsOpen = false

            setTimeout(() => {
                this.menuVisibility = false
                menuToggle.focus()
            }, 250)
        },

        setSubMenuOpen () {
            this.submenuIsOpen = true
        },

        setSubMenuClose () {
            this.submenuIsOpen = false
        },

        closeAllSubmenus () {
            Object.keys(this.$refs).forEach(key => {
                this.$refs[key].closeDropdown()
            })
        },
    },

}
